import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface TimelineEventProps {
  date: string;
  title: string;
  description: string;
  scripture?: {
    verse: string;
    reference: string;
  };
  iconName: string;
  isLeft?: boolean;
}

const TimelineEvent = ({ 
  date, 
  title, 
  description, 
  scripture, 
  iconName,
  isLeft = false 
}: TimelineEventProps) => {
  return (
    <div className={`flex items-center mb-12 ${isLeft ? 'flex-row-reverse' : 'flex-row'}`}>
      <div className={`w-full md:w-5/12 ${isLeft ? 'text-left md:pl-8' : 'text-right md:pr-8'}`}>
        <div className="bg-card rounded-lg p-6 shadow-sacred-md hover:shadow-sacred-lg transition-shadow duration-300">
          <span className="inline-block px-3 py-1 bg-primary/10 text-primary text-xs font-inter font-medium rounded-full mb-3">
            {date}
          </span>
          <h3 className="font-playfair text-xl font-semibold text-foreground mb-2">
            {title}
          </h3>
          <p className="font-inter text-sm text-muted-foreground leading-relaxed mb-4">
            {description}
          </p>
          {scripture && (
            <div className="pt-4 border-t border-border">
              <p className="font-playfair text-sm italic text-foreground mb-1">
                "{scripture.verse}"
              </p>
              <p className="font-inter text-xs text-muted">
                — {scripture.reference}
              </p>
            </div>
          )}
        </div>
      </div>
      
      <div className="relative flex items-center justify-center w-16 h-16 flex-shrink-0 mx-4">
        <div className="absolute w-full h-full bg-primary/20 rounded-full animate-pulse" />
        <div className="relative flex items-center justify-center w-12 h-12 bg-primary rounded-full shadow-sacred-md">
          <Icon name={iconName as any} size={24} className="text-white" variant="solid" />
        </div>
      </div>
      
      <div className="hidden md:block w-5/12" />
    </div>
  );
};

export default TimelineEvent;